
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 24a8 8 0 008-8 8 8 0 00-8-8 8 8 0 00-8 8 8 8 0 008 8zm5.6 2h-1.044c-1.387.637-2.931 1-4.556 1s-3.163-.363-4.556-1H18.4a8.402 8.402 0 00-8.4 8.4V37a3 3 0 003 3h22a3 3 0 003-3v-2.6c0-4.637-3.763-8.4-8.4-8.4z","fill":"#535353"}})])
          )
        }
      }
    